import { Spinner } from '@design-system';
import React, { useState } from 'react';

import { useOnBfCacheLoad } from '../../../hooks/useOnBfCacheLoad';
import { usePreAuthDrawCtx } from '../../../providers/PreAuthDrawProvider';
import { AnalyticsObjectProvider } from '../../../utils/analytics/object';
import { ReviewDrawer } from './review/ReviewDraw';

interface Props {
  product: ProductType;
}

export const PreAuthDrawer: React.FC<Props> = ({ product }) => {
  const drawController = usePreAuthDrawCtx();

  const [loading, setLoading] = useState(false);

  useOnBfCacheLoad(() => {
    setLoading(false);
  });

  if (loading || drawController.loading || !drawController.setupComplete) {
    return (
      <div className="flex aspect-[1/1] w-full items-center justify-center">
        <Spinner size="md" />
      </div>
    );
  }

  return (
    <AnalyticsObjectProvider
      name="review"
      properties={{
        'payment method available':
          drawController.paymentMethods.length > 0 ||
          drawController.usingNewPaymentMethod,
        'address available': drawController.addresses.length > 0,
        'payment method': drawController.selectedPaymentType,
      }}
      sendViewedEvent
    >
      {() => <ReviewDrawer product={product} />}
    </AnalyticsObjectProvider>
  );
};
